<script>
import { Line, mixins } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import { addDots } from '@/core/helpers/temp/util.js'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  components: {
    ChartJSPluginDatalabels,
  },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    fontSize: String,
    color: String,
  },
  data() {
    return {
      //Chart.js options that control the appearance of the chart
      options: {
        spanGaps: true,
        legend: {
          display: true,
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false,
        // Core options
        aspectRatio: 5 / 3,
        layout: {
          padding: {
            top: 32,
            right: 16,
            bottom: 16,
            left: 8,
          },
        },
        elements: {
          line: {
            fill: false,
          },
        },
        tooltips: {
          callbacks: {
            label: function (t, d) {
              var dstLabel = d.datasets[t.datasetIndex].label
              var yLabel = t.yLabel
              return ' Total ' + '"' + dstLabel + '"' + ': ' + addDots(yLabel)
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
            formatter: (value) => {
              return addDots(value)
            },
            // formatter: Math.round,
            backgroundColor: '#ddd',
            borderRadius: 4,
            color: 'white',
            font: {
              weight: 'bold',
            },
            padding: 6,
          },
        },
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
